var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classNames from 'classnames';
import RcCheckbox from 'rc-checkbox';
import { GroupContext } from './Group';
import { ConfigConsumer } from '../config-provider';
import devWarning from '../_util/devWarning';
class Checkbox extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.saveCheckbox = (node) => {
            this.rcCheckbox = node;
        };
        this.renderCheckbox = ({ getPrefixCls, direction }) => {
            const { props, context } = this;
            const { prefixCls: customizePrefixCls, className, children, indeterminate, style, onMouseEnter, onMouseLeave } = props, restProps = __rest(props, ["prefixCls", "className", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave"]);
            const checkboxGroup = context;
            const prefixCls = getPrefixCls('checkbox', customizePrefixCls);
            const checkboxProps = Object.assign({}, restProps);
            if (checkboxGroup) {
                checkboxProps.onChange = (...args) => {
                    if (restProps.onChange) {
                        restProps.onChange(...args);
                    }
                    checkboxGroup.toggleOption({ label: children, value: props.value });
                };
                checkboxProps.name = checkboxGroup.name;
                checkboxProps.checked = checkboxGroup.value.indexOf(props.value) !== -1;
                checkboxProps.disabled = props.disabled || checkboxGroup.disabled;
            }
            const classString = classNames(className, {
                [`${prefixCls}-wrapper`]: true,
                [`${prefixCls}-rtl`]: direction === 'rtl',
                [`${prefixCls}-wrapper-checked`]: checkboxProps.checked,
                [`${prefixCls}-wrapper-disabled`]: checkboxProps.disabled,
            });
            const checkboxClass = classNames({
                [`${prefixCls}-indeterminate`]: indeterminate,
            });
            return (
            // eslint-disable-next-line jsx-a11y/label-has-associated-control
            <label className={classString} style={style} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <RcCheckbox {...checkboxProps} prefixCls={prefixCls} className={checkboxClass} ref={this.saveCheckbox}/>
        {children !== undefined && <span>{children}</span>}
      </label>);
        };
    }
    componentDidMount() {
        var _a;
        const { value } = this.props;
        (_a = this.context) === null || _a === void 0 ? void 0 : _a.registerValue(value);
        if (process.env.NODE_ENV !== 'production')
            devWarning('checked' in this.props || this.context || !('value' in this.props), 'Checkbox', '`value` is not a valid prop, do you mean `checked`?');
    }
    componentDidUpdate({ value: prevValue }) {
        var _a, _b;
        const { value } = this.props;
        if (value !== prevValue) {
            (_a = this.context) === null || _a === void 0 ? void 0 : _a.cancelValue(prevValue);
            (_b = this.context) === null || _b === void 0 ? void 0 : _b.registerValue(value);
        }
    }
    componentWillUnmount() {
        var _a;
        const { value } = this.props;
        (_a = this.context) === null || _a === void 0 ? void 0 : _a.cancelValue(value);
    }
    focus() {
        this.rcCheckbox.focus();
    }
    blur() {
        this.rcCheckbox.blur();
    }
    render() {
        return <ConfigConsumer>{this.renderCheckbox}</ConfigConsumer>;
    }
}
Checkbox.__ANT_CHECKBOX = true;
Checkbox.defaultProps = {
    indeterminate: false,
};
Checkbox.contextType = GroupContext;
export default Checkbox;
